<template>
  <form>
    <v-container fluid grid-list-lg>
      <v-card>
        <v-toolbar>
          <v-icon>attach_money</v-icon>
          <v-toolbar-title class="font-weight-light"
            >Alta de Solicitud de Crédito -
            {{ tipoProductoDescripcion }}</v-toolbar-title
          >
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                text
                icon
                color="red"
                v-on="on"
                @click="setStatusTareaFrecuente(action)"
              >
                <v-icon v-if="action.esFrecuente">favorite</v-icon>
                <v-icon v-else>favorite_border</v-icon>
              </v-btn>
            </template>
            <span v-if="action.esFrecuente">Quitar de Tareas Frecuentes</span>
            <span v-else>Agregar a Tareas Frecuentes</span>
          </v-tooltip>
        </v-toolbar>

        <v-container fluid>
          <v-layout column>
            <v-flex xs12 v-if="selectedCanalVenta">
              <v-card dark color="purple">
                <v-card-text>
                  <div>
                    Solicitud para
                    <v-chip :color="selectedEmpresa.color">
                      {{ selectedEmpresa.nombre }}
                    </v-chip>
                    , en Sucursal {{ selectedCanalVenta.sucursalDescripcion }}
                  </div>
                </v-card-text>
              </v-card>
            </v-flex>
            <v-flex xs12 v-if="infoCrediticia">
              <v-card dark color="green darken-3">
                <v-card-text>
                  <div>{{ infoPersona }}</div>
                </v-card-text>
              </v-card>
            </v-flex>
            <v-flex xs12 v-if="infoCrediticia">
              <v-card dark color="blue ligthten-3">
                <v-card-text>
                  <div>{{ infoEmpleo }}</div>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>

        <div class="text-xs-center">
          <v-progress-linear
            v-show="loadingProgress"
            indeterminate
          ></v-progress-linear>
        </div>

        <v-card-text>
          <v-stepper v-model="step">
            <v-stepper-header>
              <v-stepper-step :complete="step > 1" step="1" color="orange"
                >Datos del Solicitante</v-stepper-step
              >
              <v-divider></v-divider>
              <v-stepper-step :complete="step > 2" step="2" color="orange"
                >Producto y Plan</v-stepper-step
              >
              <v-divider></v-divider>
              <v-stepper-step :complete="step > 3" step="3" color="orange">{{
                'Datos de Desembolso'
              }}</v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step :complete="step > 4" step="4" color="orange"
                >Datos Finales</v-stepper-step
              >
            </v-stepper-header>

            <v-stepper-items>
              <v-layout wrap>
                <v-flex xs8>
                  <!-- PASO 1 -->
                  <v-stepper-content step="1">
                    <ValidationObserver ref="paso1">
                      <v-card class="mb-5">
                        <v-container fluid>
                          <v-layout wrap>
                            <v-flex xs12 md6>
                              <v-autocomplete
                                v-model="model.empresaId"
                                :items="listEmpresas"
                                autocomplete="disabled"
                                item-text="nombre"
                                item-value="id"
                                label="Nueva Solicitud para la Empresa"
                                :menu-props="{ minWidth: '200' }"
                              ></v-autocomplete>
                            </v-flex>

                            <v-flex xs6 class="hidden-sm-and-down"> </v-flex>

                            <v-flex xs12 md6>
                              <v-autocomplete
                                v-model="model.canalVentaId"
                                :items="listCanalesVenta"
                                autocomplete="disabled"
                                item-text="nombre"
                                item-value="id"
                                label="a través del Canal de Venta"
                                :menu-props="{ minWidth: '200' }"
                              ></v-autocomplete>
                            </v-flex>

                            <v-flex xs6 class="hidden-sm-and-down"> </v-flex>

                            <v-flex xs12 md6>
                              <v-autocomplete
                                v-model="model.productoId"
                                :items="listProductosDisponibles"
                                @change="selectedProductoChanged"
                                item-text="productoDescripcion"
                                item-value="productoId"
                                label="¿Qué Producto va a solicitar?"
                                :menu-props="{ minWidth: '200' }"
                              ></v-autocomplete>
                              <v-chip
                                v-if="hayProductosNoDisponibles"
                                color="red"
                                text-color="white"
                                @click="showProductosNoDisponibles = true"
                                >Hay Productos no disponibles</v-chip
                              >
                            </v-flex>

                            <v-flex xs6 class="hidden-sm-and-down"> </v-flex>

                            <v-flex xs12>
                              <h3>Ingrese los datos del Solicitante</h3>
                            </v-flex>

                            <v-row align="center" dense>
                              <v-col cols="12" md="3" lg="3">
                                <v-radio-group v-model="ingresoPor">
                                  <v-radio
                                    label="Documento"
                                    class="caption"
                                    key="documento"
                                    value="documento"
                                  ></v-radio>
                                  <v-radio
                                    label="Cuil"
                                    class="caption"
                                    key="cuil"
                                    value="cuil"
                                  ></v-radio>
                                </v-radio-group>
                              </v-col>

                              <v-col
                                cols="12"
                                md="3"
                                lg="3"
                                v-if="ingresoPor == 'documento'"
                              >
                                <v-text-field
                                  label="Documento"
                                  v-model="model.documento"
                                  append-icon="search"
                                  @click:append="
                                    buscarPersonaPorDocumento(model.documento)
                                  "
                                  v-validate="'required'"
                                  data-vv-name="documento"
                                ></v-text-field>
                              </v-col>
                              <v-col
                                cols="12"
                                md="3"
                                lg="3"
                                v-if="ingresoPor == 'documento'"
                              >
                                <v-autocomplete
                                  v-model="model.personaDto.tipoSexoId"
                                  :items="listSexos"
                                  item-text="descripcion"
                                  item-value="id"
                                  label="Sexo"
                                  :menu-props="{ minWidth: '200' }"
                                  :disabled="!canEditNombre"
                                ></v-autocomplete>
                              </v-col>
                              <v-col
                                cols="12"
                                md="3"
                                lg="3"
                                v-if="ingresoPor == 'cuil'"
                              >
                                <v-text-field
                                  label="CUIL"
                                  v-model="model.cui"
                                  append-icon="search"
                                  @click:append="
                                    buscarPersonaPorDocumento(model.cui)
                                  "
                                  v-validate="'required'"
                                  data-vv-name="cuil"
                                ></v-text-field>
                              </v-col>

                              <v-col cols="12" md="3" lg="3">
                                <v-row dese>
                                  <v-col>
                                    <v-chip
                                      class="ml-3"
                                      small
                                      color="green"
                                      text-color="white"
                                      v-if="
                                        infoCrediticia != null &&
                                        infoCrediticia.tipoCalificacionId == 1
                                      "
                                      >{{
                                        infoCrediticia.tipoCalificacionDescripcion
                                      }}</v-chip
                                    >
                                    <v-chip
                                      class="ml-3"
                                      small
                                      color="orange"
                                      text-color="white"
                                      v-if="
                                        infoCrediticia != null &&
                                        infoCrediticia.tipoCalificacionId > 1
                                      "
                                      >{{
                                        infoCrediticia.tipoCalificacionDescripcion
                                      }}</v-chip
                                    >
                                    <app-creditos-para-refinanciar-renovar
                                      v-if="model.personaDto.id"
                                      :personaId.sync="model.personaDto.id"
                                      :empresaId="model.empresaId"
                                      :selectedCuotas.sync="
                                        model.cuotasARefinanciarORenovar
                                      "
                                      v-on:listchange="
                                        model.cuotasARefinanciarORenovar =
                                          $event
                                      "
                                    ></app-creditos-para-refinanciar-renovar>
                                  </v-col>
                                </v-row>
                              </v-col>
                              <!-- <v-col cols="12" md="6" lg="4">
                            </v-col> -->
                            </v-row>

                            <v-row>
                              <v-col cols="12" sm="4" lg="3">
                                <ValidationProvider
                                  name="nombre"
                                  rules="required"
                                >
                                  <v-text-field
                                    type="text"
                                    label="Nombre"
                                    v-model="model.personaDto.nombre"
                                    autocomplete="disabled"
                                    data-vv-name="nombre"
                                    slot-scope="{ errors, valid }"
                                    :error-messages="errors"
                                    :success="valid"
                                    :disabled="!canEditNombre"
                                  ></v-text-field>
                                </ValidationProvider>
                              </v-col>

                              <v-col cols="12" sm="4" lg="3">
                                <ValidationProvider
                                  name="apellido"
                                  rules="required"
                                >
                                  <v-text-field
                                    label="Apellido"
                                    v-model="model.personaDto.apellido"
                                    autocomplete="disabled"
                                    data-vv-name="apellido"
                                    slot-scope="{ errors, valid }"
                                    :error-messages="errors"
                                    :success="valid"
                                    :disabled="!canEditNombre"
                                  ></v-text-field>
                                </ValidationProvider>
                              </v-col>

                              <v-col cols="12" sm="4" lg="3">
                                <ValidationProvider
                                  name="fecha de nacimiento"
                                  rules="required"
                                >
                                  <v-text-field
                                    label="Fecha Nacimiento"
                                    v-model="model.personaDto.fechaNacimiento"
                                    type="date"
                                    prepend-icon="event"
                                    data-vv-name="fecha de nacimiento"
                                    slot-scope="{ errors, valid }"
                                    :error-messages="errors"
                                    :success="valid"
                                  ></v-text-field>
                                </ValidationProvider>
                              </v-col>

                              <v-col cols="12" sm="4" lg="2">
                                <ValidationProvider
                                  name="ingreso mensual"
                                  rules="required|decimal:2|min_value:1000"
                                >
                                  <v-text-field
                                    label="Ingreso Mensual"
                                    v-model="
                                      model.personaDto.empleo.ingresoNeto
                                    "
                                    data-vv-name="ingreso mensual"
                                    slot-scope="{ errors, valid }"
                                    :error-messages="errors"
                                    :success="valid"
                                  ></v-text-field>
                                </ValidationProvider>
                              </v-col>
                            </v-row>

                            <v-flex xs6 md4 lg4>
                              <ValidationProvider
                                name="trabaja"
                                rules="required"
                              >
                                <v-radio-group
                                  label="Trabaja?"
                                  row
                                  v-model="model.trabaja"
                                  data-vv-name="trabaja"
                                  slot-scope="{ errors, valid }"
                                  :error-messages="errors"
                                  :success="valid"
                                >
                                  <v-radio label="Si" value="true"></v-radio>
                                  <v-radio label="No" value="false"></v-radio>
                                </v-radio-group>
                              </ValidationProvider>
                            </v-flex>

                            <v-flex xs12 md4>
                              <ValidationProvider
                                v-if="model.trabaja == 'true'"
                                name="fuente de ingresos principal"
                                rules="required"
                              >
                                <v-autocomplete
                                  v-show="model.trabaja == 'true'"
                                  v-model="
                                    model.personaDto.tipoSituacionLaboralId
                                  "
                                  :items="listSituacionesLaborales"
                                  item-text="descripcion"
                                  item-value="id"
                                  label="Su fuente de Ingresos es"
                                  :menu-props="{ minWidth: '200' }"
                                  @change="situacionLaboralChanged"
                                  data-vv-name="fuente de ingresos principal"
                                  slot-scope="{ errors, valid }"
                                  :error-messages="errors"
                                  :success="valid"
                                ></v-autocomplete>
                              </ValidationProvider>
                            </v-flex>
                          </v-layout>
                        </v-container>

                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn color="primary" @click="nextStep(1)">
                            Siguiente Paso
                          </v-btn>

                          <v-btn text @click="cancelar">Cancelar</v-btn>
                        </v-card-actions>
                      </v-card>
                    </ValidationObserver>
                  </v-stepper-content>

                  <!-- PASO 2 -->
                  <v-stepper-content step="2">
                    <v-card class="mb-5">
                      <v-container fluid>
                        <v-layout row>
                          <v-flex xs12 md10 lg7>
                            <v-layout wrap>
                              <v-flex xs10 md5>
                                <v-autocomplete
                                  v-model="model.planId"
                                  :items="listPlanesDisponibles"
                                  @change="selectedPlanChanged"
                                  item-text="planNombre"
                                  item-value="planId"
                                  label="Planes Disponibles"
                                  :menu-props="{ minWidth: '200' }"
                                ></v-autocomplete>

                                <v-chip
                                  v-if="hayPlanesNoDisponibles"
                                  color="red"
                                  text-color="white"
                                  @click="showPlanesNoDisponibles = true"
                                  >Hay Planes no disponibles</v-chip
                                >
                              </v-flex>

                              <v-flex xs12 lg12 row>
                                <v-radio-group row v-model="ingresoPorMonto">
                                  <v-radio
                                    label="Ingresar Monto"
                                    value="true"
                                    @click="
                                      importeCuotaMaximaIngresado = 0;
                                      ingresoPorMonto = 'true';
                                    "
                                  ></v-radio>
                                  <v-radio
                                    label="Ingresar Cuota Máxima"
                                    value="false"
                                    @click="
                                      capitalIngresado = 0;
                                      ingresoPorMonto = 'false';
                                    "
                                  ></v-radio>
                                </v-radio-group>
                              </v-flex>

                              <v-flex
                                xs12
                                md4
                                v-show="ingresoPorMonto == 'true'"
                              >
                                <v-text-field
                                  label="Solicita"
                                  v-model="capitalIngresado"
                                ></v-text-field>
                              </v-flex>
                              <v-flex
                                xs12
                                md4
                                v-show="ingresoPorMonto == 'false'"
                              >
                                <v-text-field
                                  label="Cuota Máxima"
                                  v-model="importeCuotaMaximaIngresado"
                                ></v-text-field>
                              </v-flex>

                              <v-flex xs12 md8>
                                <v-btn
                                  color="blue-grey"
                                  outlined
                                  @click="calcularOpcionesPlan"
                                >
                                  Recalcular
                                </v-btn>
                              </v-flex>
                              <v-flex xs12 md12>
                                <v-chip
                                  v-if="
                                    politicaComercial &&
                                    politicaComercial.restringeCapital
                                  "
                                  color="green lighten-2"
                                  text-color="white"
                                  >Ofrecer Capital Entre $
                                  {{ politicaComercial.capitalDesde }} y $
                                  {{ politicaComercial.capitalHasta }}</v-chip
                                >
                              </v-flex>
                            </v-layout>
                          </v-flex>

                          <v-flex xs12 md2 lg5>
                            <v-layout column>
                              <v-flex>
                                <v-card>
                                  <v-card-title>
                                    <h6 v-show="ingresoPorMonto == 'true'">
                                      Puede Solicitar $
                                      {{ capitalIngresado }} en
                                    </h6>
                                    <h6 v-show="ingresoPorMonto == 'false'">
                                      Puede Solicitar
                                    </h6>
                                  </v-card-title>
                                  <v-card-text>
                                    <v-radio-group row v-model="indiceOferta">
                                      <v-radio
                                        v-for="item in opcionesPlanes"
                                        @change="setCuotaSeleciconada(item)"
                                        :key="item.indice"
                                        :label="item.oferta"
                                        :value="item.indice"
                                      ></v-radio>
                                    </v-radio-group>
                                  </v-card-text>
                                </v-card>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                      </v-container>

                      <v-card-actions>
                        <v-btn color="primary" @click="step = step - 1">
                          Volver
                        </v-btn>

                        <v-spacer></v-spacer>
                        <v-btn
                          color="primary"
                          @click="nextStep(2)"
                          :disabled="!puedeContinuarPaso2"
                        >
                          Siguiente Paso
                        </v-btn>

                        <v-btn text @click="cancelar">Cancelar</v-btn>
                      </v-card-actions>

                      <v-snackbar
                        v-model="hayErroresPolitica"
                        color="red"
                        bottom
                        :timeout="60000"
                      >
                        {{ errorPolitica }}
                        <v-btn dark text @click="hayErroresPolitica = false">
                          Cerrar
                        </v-btn>
                      </v-snackbar>
                    </v-card>
                  </v-stepper-content>

                  <!-- PASO 3 -->
                  <v-stepper-content step="3" v-if="model.trabaja">
                    <v-card class="mb-5">
                      <v-layout>
                        <v-flex xs12>
                          <v-card dark color="blue ligthten-3">
                            <v-card-text>
                              <div>{{ infoCredito }}</div>
                            </v-card-text>
                          </v-card>
                        </v-flex>
                      </v-layout>

                      <v-container fluid>
                        <ValidationObserver ref="paso3">
                          <v-row>
                            <h3>Especifique los siguientes datos</h3>
                          </v-row>

                          <v-row>
                            <v-col cols="12" lg="6">
                              <ValidationProvider
                                name="medio de pago"
                                rules="required"
                              >
                                <v-autocomplete
                                  v-model="model.tipoMedioPagoId"
                                  :items="listMediosPago"
                                  item-text="descripcion"
                                  item-value="id"
                                  label="El desembolso del crédito será mediante"
                                  :menu-props="{ minWidth: '200' }"
                                  data-vv-name="medio de pago"
                                  slot-scope="{ errors, valid }"
                                  :error-messages="errors"
                                  :success="valid"
                                ></v-autocomplete>
                              </ValidationProvider>
                            </v-col>
                          </v-row>

                          <v-row>
                            <v-col cols="12" lg="6">
                              <ValidationProvider
                                name="forma de llegada"
                                rules="required"
                              >
                                <v-autocomplete
                                  v-model="model.tipoFormaLlegadaId"
                                  :items="listFormasLlegada"
                                  item-text="descripcion"
                                  item-value="id"
                                  label="Indique cómo llegó el solicitante"
                                  :menu-props="{ minWidth: '200' }"
                                  data-vv-name="forma de llegada"
                                  slot-scope="{ errors, valid }"
                                  :error-messages="errors"
                                  :success="valid"
                                ></v-autocomplete>
                              </ValidationProvider>
                            </v-col>
                          </v-row>

                          <v-row>
                            <v-col cols="12" lg="6">
                              <ValidationProvider
                                name="motivo de la solicitud"
                                rules="required"
                              >
                                <v-autocomplete
                                  v-model="model.tipoMotivoSolicitudId"
                                  :items="listDestinosCredito"
                                  item-text="descripcion"
                                  item-value="id"
                                  label="Indique cuál es el destino del crédito"
                                  :menu-props="{ minWidth: '200' }"
                                  data-vv-name="motivo de la solicitud"
                                  slot-scope="{ errors, valid }"
                                  :error-messages="errors"
                                  :success="valid"
                                ></v-autocomplete>
                              </ValidationProvider>
                            </v-col>
                          </v-row>

                          <v-row
                            v-if="
                              tipoProductoDescripcion
                                .toUpperCase()
                                .includes('DIRIGIDO CONSUMO')
                            "
                          >
                            <v-col cols="12" lg="6">
                              <ValidationProvider
                                name="producto a entregar"
                                rules="required"
                              >
                                <v-text-field
                                  label="Producto A Entregar"
                                  v-model="model.productoAEntregar"
                                  v-validate="'required'"
                                  data-vv-name="productoAEntregar"
                                ></v-text-field>
                              </ValidationProvider>
                            </v-col>
                          </v-row>

                          <v-row>
                            <h3>Datos de la Cuenta Bancaria</h3>
                          </v-row>

                          <!-- <v-flex xs12 md6 lg4>
                              <v-text-field label="CBU" v-model="model.cbu" counter ></v-text-field>
                          </v-flex> -->

                          <v-row>
                            <v-col cols="12" lg="6">
                              <v-switch
                                v-model="model.solicitaDebito"
                                label="Solicita Débito en Cuenta "
                              >
                              </v-switch>
                            </v-col>
                          </v-row>

                          <v-row v-if="model.solicitaDebito" no-gutters>
                            <v-col cols="12">
                              <!-- <v-text-field label="CBU" v-model="model.cbu" counter ></v-text-field> -->
                              <app-datos-debito-credito
                                :standAloneMode="false"
                                :personaId="model.personaId"
                                :tipoSituacionLaboralId="
                                  model.personaDto.tipoSituacionLaboralId
                                "
                                :documento="model.personaDto.documento"
                                :subSituacionLaboralId="
                                  subSituacionLaboralEmpleo
                                "
                                :cuentaSeleccionada="model.cuentaDebito"
                              ></app-datos-debito-credito>
                            </v-col>
                          </v-row>
                          <!-- <v-flex lg2 sm6 xs12>
                              <v-autocomplete v-model="model.diaCobroId" :items="listDiasCobro" 
                                  item-text="descripcion" item-value="id" label="Día de Cobro"  :menu-props="{minWidth:'200'}"></v-autocomplete>
                          </v-flex> -->

                          <!-- Pago por tarjeta de crédito (COIN)-->

                          <v-row>
                            <v-col>
                              <h3>Datos de la Tarjeta de Débito</h3>
                            </v-col>
                          </v-row>

                          <v-row no-gutters>
                            <v-col cols="6">
                              <v-switch
                                v-model="model.solicitaDebitoATarjeta"
                                label="Completar Datos"
                              >
                              </v-switch>
                            </v-col>
                          </v-row>

                          <v-row v-if="model.solicitaDebitoATarjeta" no-gutters>
                            <v-col cols="10">
                              <v-radio-group
                                row
                                v-model="model.tarjetaDebito.activa"
                              >
                                <v-radio
                                  label="Débito Activo"
                                  :value="true"
                                ></v-radio>
                                <v-radio
                                  label="Inactivo"
                                  :value="false"
                                ></v-radio>
                              </v-radio-group>
                            </v-col>
                          </v-row>

                          <v-row v-if="model.solicitaDebitoATarjeta" no-gutters>
                            <v-col cols="10">
                              <app-datos-tarjeta
                                v-on:token-generado="updateDatosTarjeta($event)"
                                v-on:datos-actualizados="
                                  updateDatosTarjeta($event)
                                "
                                :standAloneMode="false"
                                :empresaId="model.empresaId"
                                :personaId="model.personaId"
                                :tarjetaSeleccionada="model.tarjetaDebito"
                                :cuotasPendientesCredito="model.cuotas"
                              ></app-datos-tarjeta>
                            </v-col>
                          </v-row>
                        </ValidationObserver>
                      </v-container>
                    </v-card>

                    <v-card-actions>
                      <v-btn color="primary" @click="step = step - 1">
                        Volver
                      </v-btn>

                      <v-spacer></v-spacer>
                      <v-btn color="primary" @click="validarMontoCuotas">
                        Siguiente Paso
                      </v-btn>

                      <v-btn text @click="cancelar">Cancelar</v-btn>
                    </v-card-actions>
                  </v-stepper-content>

                  <!-- PASO 4 -->
                  <v-stepper-content step="4">
                    <v-card class="mb-5" height="400">
                      <v-layout>
                        <v-flex xs12>
                          <v-card dark color="blue ligthten-3">
                            <v-card-text>
                              <div>{{ infoCredito }}</div>
                            </v-card-text>
                          </v-card>
                        </v-flex>
                      </v-layout>

                      <v-container fluid>
                        <v-layout wrap>
                          <v-flex xs6 class="hidden-sm-and-down"> </v-flex>

                          <v-flex xs12 v-if="model.calificacionPersonaId <= 1">
                            <v-layout>
                              <v-flex xs6>
                                <h3>
                                  El solicitante es Nuevo, por lo que debe
                                  completar el Legajo del mismo
                                </h3>
                              </v-flex>
                              <v-flex xs3>
                                <v-btn outlined @click="showLegajo = true"
                                  >Completar Legajo</v-btn
                                >
                              </v-flex>
                              <v-flex xs4>
                                <v-icon v-if="legajoCheck" color="green"
                                  >done_outline</v-icon
                                >
                              </v-flex>
                            </v-layout>
                          </v-flex>

                          <v-flex xs12 v-if="model.calificacionPersonaId > 1">
                            <v-layout>
                              <v-flex xs4>
                                <h3>
                                  El solicitante ya es Cliente, revise el legajo
                                  y actualice los datos que sean necesarios
                                </h3>
                              </v-flex>
                              <v-flex xs3>
                                <v-btn outlined @click="showLegajo = true"
                                  >Completar Legajo</v-btn
                                >
                              </v-flex>
                              <v-flex xs4>
                                <v-icon v-if="legajoCheck" color="green"
                                  >done_outline</v-icon
                                >
                              </v-flex>
                            </v-layout>
                          </v-flex>

                          <v-flex xs12>
                            <v-text-field
                              v-model="model.observaciones"
                              label="Si es necesario puede ingresar algún comentario para el analista"
                            ></v-text-field>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-card>

                    <v-card-actions>
                      <v-btn color="primary" @click="step = step - 1">
                        Volver
                      </v-btn>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" @click="confirmarAlta">
                        Confirmar Operación
                      </v-btn>

                      <v-btn text @click="cancelar">Cancelar</v-btn>
                    </v-card-actions>
                  </v-stepper-content>
                </v-flex>

                <v-flex xs4>
                  <v-container>
                    <v-layout wrap>
                      <v-flex>
                        <v-text-field
                          v-model="model.politicaComercialId"
                          label="PoliticaId"
                          v-if="$store.state.debugModeOn"
                        ></v-text-field>
                        <app-validador-politica-comercial
                          v-if="model.politicaComercialId > 0"
                          :politica="this.politicaComercial"
                          :ParametrosAValidar="model"
                          v-bind:PoliticaAprobada.sync="politicaAprobada"
                          v-bind:ErroresPolitica.sync="errorPolitica"
                          v-bind:AutorizadoPorExcepcion.sync="
                            model.seAutorizoPorExcepcion
                          "
                          v-bind:AutorizadoPorUsuario.sync="
                            model.usuarioQueAutorizo
                          "
                          v-bind:AutorizadoPorMotivo.sync="
                            model.motivoAutorizacion
                          "
                        ></app-validador-politica-comercial>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-flex>
              </v-layout>
            </v-stepper-items>
          </v-stepper>
        </v-card-text>
      </v-card>
      <app-loading :loading="loading"></app-loading>

      <!-- productos no disponibles -->
      <v-dialog v-model="showProductosNoDisponibles" width="600">
        <v-card :dark="$store.state.UiCustomUserSettings.temaOscuro">
          <v-card-title class="headline">Producos No disponibles</v-card-title>
          <v-card-text>
            <v-layout wrap>
              <v-list>
                <v-list-item
                  v-for="item in listProductos.filter((p) => !p.estaDisponible)"
                  :key="item.productoId"
                >
                  <template>
                    <h5>{{ item.productoDescripcion }}:</h5>
                    <div class="caption">{{ item.motivoNoDisponible }}</div>
                  </template>
                </v-list-item>
              </v-list>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-dialog>

      <!-- planes no disponibles -->
      <v-dialog v-model="showPlanesNoDisponibles" width="600">
        <v-card :dark="$store.state.UiCustomUserSettings.temaOscuro">
          <v-card-title class="headline">Planes No disponibles</v-card-title>
          <v-card-text>
            <v-layout wrap>
              <v-list>
                <v-list-item
                  v-for="item in listPlanes.filter((p) => !p.estaDisponible)"
                  :key="item.planId"
                >
                  <template>
                    <h5>{{ item.planNombre }}:</h5>
                    <div class="caption">{{ item.motivoNoDisponible }}</div>
                  </template>
                </v-list-item>
              </v-list>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-dialog>

      <!-- legajo  -->
      <v-dialog v-model="showLegajo" width="1000" persistent>
        <v-card :dark="$store.state.UiCustomUserSettings.temaOscuro">
          <v-card-title class="headline">Legajo de la Persona</v-card-title>
          <v-card-text>
            <legajo-persona
              :value="model.personaDto"
              :visible="showLegajo"
              :legajoGuardado="legajoGuardado"
            ></legajo-persona>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-container>
    <template v-if="$store.state.debugModeOn">
      Debug Info:
      <p></p>

      Model: {{ model }}
      <p></p>
      Ingreso Por Monto: {{ ingresoPorMonto }}
      <p></p>
      Errores Política: {{ errorPolitica }} Politica Aprobada:
      {{ politicaAprobada }}
    </template>
  </form>
</template>

<script>
import Vue from 'vue';
import { http } from '@/axios';
import { ValidationObserver, ValidationProvider } from 'vee-validate';

import LegajoPersona from './DatosLegajo';

import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import { constants } from 'crypto';

export default {
  components: {
    ValidationObserver,
    ValidationProvider,
    'legajo-persona': LegajoPersona,
  },
  data() {
    return {
      step: 3,
      loading: false,
      loadingProgress: false, // Lo uso para la progress bar
      editMode: true,
      showProductosNoDisponibles: false,
      showPlanesNoDisponibles: false,
      showLegajo: false,
      model: {
        personaId: null,
        cuentaDebito: {},
        solicitaDebito: false,
        tipoMedioPagoId: 1,
        planId: 0,
        solicitaDebitoATarjeta: false,
      },
      selectedPersonaBusqueda: null,
      infoCrediticia: null,
      importe: 0,
      listSituacionesLaborales: [],
      listEmpresas: [],
      listCanalesVentaHabilitados: [],
      listProductos: [],
      listProductosDisponibles: [],
      listPlanes: [],
      listPlanesDisponibles: [],
      listSexos: [],
      listMediosPago: [],
      listDiasCobro: [],
      listFormasLlegada: [],
      listDestinosCredito: [],
      listEntidadesFinancieras: [],
      ingresoPorMonto: 'true',
      politicaComercial: {},
      opcionesPlanes: [],
      cuotaSeleccionada: { cuotas: 0 },
      politicaAprobada: false,
      errorPolitica: '',
      hayErroresPolitica: false,
      legajoCheck: false,
      indiceOferta: 0,
      capitalIngresado: 0,
      importeCuotaMaximaIngresado: 0,
      showSaveProgress: false,
      saving: false,
      uploading: false,
      ingresoPor: ('documento', 'nombre', 'telefono'),

      canEditNombre: true,
      productoDescripcion: '',
    };
  },
  async created() {
    this.clear();
    this.loadCanalesVentaHabilitados();
    this.loadSituacionesLaborales();
    this.loadSexo();
    this.loadDiasCobro();
    this.loadMediosPago();
    this.loadFormasLlegada();
    this.loadDestinosCredito();
    this.loadEntidadesFinancieras();

    this.ingresoPor =
      this.$store.state.parametrosGenerales.ingresoPorDefectoPor;
  },
  watch: {
    'model.canalVentaId': async function () {
      // cargo los productos disponibles
      await this.loadProductosDisponibles();
    },
    'model.planId': async function () {
      // si el plan tiene como medio de cobro Debito en Cuenta, pongo como predeterminado el tilde de solicita debito
      // y la forma de pago x transferencia
      var plan = this.listPlanesDisponibles.find(
        (i) => (i.id = this.model.planId)
      );
      if (plan.requiereDebitoEnCuenta) {
        this.model.solicitaDebito = true;
        this.model.tipoMedioPagoId = 2;
      }
    },
    errorPolitica: function () {
      // cargo los productos disponibles
      this.hayErroresPolitica = this.errorPolitica != '';
      this.model.motivoSolicitudAutorizacion = this.errorPolitica;
    },
  },
  computed: {
    ...mapGetters([
      'user',
      'UiCustomUserSettings',
      'DebugModeOn',
      'getActionFromLink',
    ]),
    subSituacionLaboralEmpleo: function () {
      return this.model.personaDto.empleo != null
        ? this.model.personaDto.empleo.subSituacionLaboralId
        : null;
    },
    action: function () {
      return this.getActionFromLink(this.$route.path);
    },
    listCanalesVenta: function () {
      // devuelvo los canales de venta de la empresa seleccionada
      let canalesDisponibles = this.listCanalesVentaHabilitados.filter(
        (i) => i.empresaId == this.model.empresaId
      );

      return canalesDisponibles;
    },
    selectedEmpresa: function () {
      if (this.model.empresaId && this.model.empresaId > 0)
        return this.listEmpresas.find((i) => i.id === this.model.empresaId);

      return null;
    },
    selectedCanalVenta: function () {
      if (this.model.canalVentaId && this.model.canalVentaId > 0)
        return this.listCanalesVentaHabilitados.find(
          (i) => i.id === this.model.canalVentaId
        );

      return null;
    },
    edad: function () {
      if (!this.persona) return '-';

      var dob = this.$moment(this.model.fechaNacimiento);

      if (dob.isValid) {
        var ageDifMs = Date.now() - dob.toDate().getTime();
        var ageDate = new Date(ageDifMs); // miliseconds from epoch
        return Math.abs(ageDate.getUTCFullYear() - 1970) + ' años';
      }
      return '-';
    },
    infoPersona: function () {
      if (!this.infoCrediticia) return null;

      var dob = this.$moment(this.model.personaDto.fechaNacimiento);

      var edad = '';
      if (dob.isValid) {
        var ageDifMs = Date.now() - dob.toDate().getTime();
        var ageDate = new Date(ageDifMs); // miliseconds from epoch
        edad = Math.abs(ageDate.getUTCFullYear() - 1970) + ' años';
      }

      var info =
        'Solicitante ' +
        this.infoCrediticia.tipoCalificacionDescripcion +
        ': ' +
        this.model.personaDto.nombre +
        ' ' +
        this.model.personaDto.apellido +
        ', ' +
        this.infoCrediticia.documentoCompleto +
        ', edad ' +
        edad;
      return info;
    },
    infoEmpleo: function () {
      if (!this.infoCrediticia && !this.model.personaDto) return null;

      var info = '';
      if (!this.model.personaDto.empleo || this.model.personaDto.empleo == null)
        return 'No tiene empleo cargado';

      //console.log('this.model.personaDto')
      //console.log(this.model.personaDto)
      switch (this.model.personaDto.tipoSituacionLaboralId) {
        case 0: // nuevo
          info = 'Situación Laboral no especificada';
          break;
        case 1: // relación de dependencia
          if (this.model.personaDto.empleo.empleador == '')
            info = 'No registra empleo ';
          else info = 'Trabaja en ' + this.model.personaDto.empleo.empleador;
          break;
        case 2: // autónomo
        case 3: // monotributista
        case 4: // jubi
          info =
            'Es ' +
            this.listSituacionesLaborales.find(
              (i) => i.id === this.model.personaDto.tipoSituacionLaboralId
            ).descripcion;
          break;
        case 5: // fuerzas
          info =
            'Pertenece a las ' +
            this.listSituacionesLaborales.find(
              (i) => i.id === this.model.personaDto.tipoSituacionLaboralId
            ).descripcion;
          break;
        case 6: // fuerzas
          info = 'Realiza otras actividades ';
          break;
        default:
          info =
            'Es ' +
            this.listSituacionesLaborales.find(
              (i) => i.id === this.model.personaDto.tipoSituacionLaboralId
            ).descripcion;
          break;
      }

      if (this.model.personaDto.empleo.ingresoNeto > 0) {
        info =
          info +
          ' con un ingreso mensual de $ ' +
          this.model.personaDto.empleo.ingresoNeto;
      } else {
        info = info + ', no registra ingresos';
      }

      return info;
    },
    infoCredito: function () {
      if (this.cuotaSeleccionada == 0)
        return 'No se seleccionó la cantidad de cuotas';

      return (
        'Se está solicitando un monto de $' +
        this.model.capital +
        ' en ' +
        this.cuotaSeleccionada.cuotas +
        ' de $ ' +
        this.cuotaSeleccionada.importeCuota
      );
    },
    hayProductosNoDisponibles: function () {
      return (
        this.listProductos &&
        this.listProductos.filter((p) => !p.estaDisponible).length > 0
      );
    },
    hayPlanesNoDisponibles: function () {
      return (
        this.listPlanes &&
        this.listPlanes.filter((p) => !p.estaDisponible).length > 0
      );
    },
    puedeContinuarPaso2: function () {
      return (
        this.model.cuotas &&
        this.model.cuotas > 0 &&
        this.model.planId &&
        this.model.planId > 0
      );
    },
    tipoProductoDescripcion: function () {
      if (this.listProductos && this.model.productoId > 0) {
        return this.listProductos.find(
          (p) => p.productoId === this.model.productoId
        ).tipoProductoDescripcion;
      }
      return '';
    },
  },
  methods: {
    ...mapMutations([
      'alertClear',
      'alertSuccess',
      'alertWarning',
      'alertError',
    ]),
    ...mapActions(['setStatusTareaFrecuente']),
    async nextStep(currentStep) {
      if (currentStep == 1) {
        if (!this.model.productoId || this.model.productoId == 0) {
          this.alertError(
            'Antes de continuar, seleccione el Producto a solicitar'
          );
          return;
        }

        if (!this.infoCrediticia) {
          this.alertError(
            'Antes de continuar, realice la búsqueda del solcitante (con la lupita al lado del documento)'
          );
          return;
        }

        let result = await this.$refs.paso1.validate();
        if (!result) {
          this.alertWarning(
            'Por favor, complete los datos requeridos para continuar.'
          );
          return;
        }

        this.loadPlanesDisponibles();
        this.step++;
      } else if (currentStep == 2) {
        this.step++;
      } else if (currentStep == 3) {
        let result = await this.$refs.paso3.validate();
        if (!result) {
          this.alertWarning(
            'Por favor, complete los datos requeridos para continuar.'
          );
          return;
        }
        this.step++;
      }
    },
    async confirmarAlta() {
      if (!this.politicaAprobada) {
        this.alertWarning(
          'La Política no ha sido validada. Imposible continuar.'
        );
        return;
      }

      if (!this.legajoCheck) {
        this.alertWarning(
          'Por favor, revise y complete el Legajo de Solicitante antes de confirmar.'
        );
        return;
      }

      if (
        this.tipoProductoDescripcion
          .toUpperCase()
          .includes('DIRIGIDO CONSUMO') &&
        !this.model.productoAEntregar
      ) {
        this.alertWarning('Por favor, ingrese el Producto a Entregar.');
        return;
      }

      if (this.model.solicitaDebito) {
        if (!this.model.cuentaDebito) {
          this.alertWarning(
            'Por favor, ingrese los datos de la Cuenta de Débito.'
          );
          return;
        }

        if (
          !this.model.cuentaDebito.debitoATitular &&
          !this.model.cuentaDebito.debitoAGarante
        ) {
          this.alertWarning(
            'Por favor, indique si el débito se realizará el Titular o al Garante.'
          );
          return;
        }

        if (
          this.model.cuentaDebito.altaCuenta &&
          this.model.cuentaDebito.cbu == ''
        ) {
          this.alertWarning(
            'Por favor, ingrese los datos de la nueva Cuenta de Débito.'
          );
          return;
        }

        if (
          !this.model.cuentaDebito.altaCuenta &&
          this.model.cuentaDebito.cuentaBancoId == null
        ) {
          this.alertWarning('Por favor, seleccione la Cuenta de Débito.');
          return;
        }

        if (!this.model.cuentaDebito.diaCobroId) {
          this.alertWarning('Por favor, seleccione el Día de Cobro.');
          return;
        }
      }

      if (this.model.solicitaDebitoATarjeta) {
        if (
          !this.model.tarjetaDebito ||
          (!this.model.tarjetaDebito.tarjetaValidada &&
            this.model.tarjetaDebito.marcaId != 3)
        ) {
          this.alertWarning(
            'Por favor, ingrese y valide la Tarjeta a debitar.'
          );
          return;
        }
      }

      this.loading = true;
      try {
        this.model.politicaComercialId = this.politicaComercial.id;
        this.model.personaId = this.model.personaDto.id;

        var result = await http.post(
          'creditos',
          JSON.stringify({ solicitud: this.model })
        );

        console.log(result.entity);

        if (result.entity.avisos == '')
          this.alertSuccess('La solicitud de crédito ha sido registrada.');
        else {
          this.$dialog.notify.info(result.entity.avisos, {
            position: 'top-right',
            timeout: 10000,
          });
        }

        this.clear();
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async setCuotaSeleciconada(item) {
      this.indiceOferta = item.indice;
      this.cuotaSeleccionada = item;
      this.model.capital = this.cuotaSeleccionada.capital;
      this.model.cuotas = this.cuotaSeleccionada.cuotas;
      this.model.importeCuota = this.cuotaSeleccionada.importeCuota;
      this.model.tablaCoeficientesId =
        this.cuotaSeleccionada.tablaCoeficienteId;
    },
    async selectedProductoChanged(value) {
      if (value == 0) {
        this.productoDescripcion = '';
        return;
      }

      this.productoDescripcion = this.listProductos.find(
        (p) => p.productoId === value
      ).productoDescripcion;
      await this.setPoliticaComercial();
    },
    async selectedPlanChanged(value) {
      if (value == 0) return;

      await this.setPoliticaComercial();
      await this.calcularOpcionesPlan();
    },
    async situacionLaboralChanged() {
      if (this.model.personaDto.empleo)
        this.model.personaDto.empleo.situacionLaboralId =
          this.model.personaDto.tipoSituacionLaboralId;
    },
    async calcularOpcionesPlan() {
      this.opcionesPlanes = [];

      if (this.capitalIngresado == 0 && this.importeCuotaMaximaIngresado == 0)
        return;

      this.model.cuotas = 0;
      this.errorPolitica = '';

      this.loading = true;
      try {
        var result = await http.get(
          'businesscore/calcularopcionesplanparacredito' +
            '?planId=' +
            this.model.planId +
            '&empresaId=' +
            this.model.empresaId +
            '&canalVentaId=' +
            this.model.canalVentaId +
            '&calificacionPersonaId=' +
            this.infoCrediticia.tipoCalificacionId +
            '&politicaComercialId=' +
            this.model.politicaComercialId +
            '&diaCobro=' +
            '0' +
            '&capital=' +
            this.capitalIngresado +
            '&importeCuotaMaximo=' +
            this.importeCuotaMaximaIngresado +
            '&ingresoMensual=' +
            this.model.personaDto.empleo.ingresoNeto +
            '&fechaCarga=' +
            this.model.fechaCarga +
            '&excepcionAprobada=' +
            this.politicaAprobada
        );

        this.opcionesPlanes = result.list;
        if (result.list.length == 0) {
          this.alertWarning(
            'No se encontraron opciones de cuota para el plan seleccionado.'
          );
        }
      } catch (error) {
        if (JSON.stringify(error).includes('Politica')) {
          this.errorPolitica = error;
        } else {
          // Error
          this.alertError(error);
        }
      }
      this.loading = false;
    },
    async setPoliticaComercial() {
      // busco la política que se esá aplicando en base al producto o plan seleccionado
      if (
        this.$store.state.parametrosGenerales.politicaComercialPor == 'producto'
      )
        if (!this.infoCrediticia || !(this.model.productoId > 0)) return;

      if (this.$store.state.parametrosGenerales.politicaComercialPor == 'plan')
        if (!this.infoCrediticia || !(this.model.planId > 0)) return;

      this.loadingProgress = true;

      if (
        this.$store.state.parametrosGenerales.politicaComercialPor == 'producto'
      ) {
        try {
          var result = await http.get(
            'businesscore/establecerpoliticacomercial' +
              '?productoId=' +
              this.model.productoId +
              '&empresaId=' +
              this.model.empresaId +
              '&canalVentaId=' +
              this.model.canalVentaId +
              '&calificacionPersonaId=' +
              this.infoCrediticia.tipoCalificacionId
          );

          console.log('Política x Producto:');
          console.log(result);

          this.politicaComercial = result;
          this.model.politicaComercialId = this.politicaComercial.id;
        } catch (error) {
          // Error
          this.alertError(error);
        }
      } else {
        try {
          var result = await http.get(
            'businesscore/establecerpoliticacomercial' +
              '?planId=' +
              this.model.planId +
              '&empresaId=' +
              this.model.empresaId +
              '&canalVentaId=' +
              this.model.canalVentaId +
              '&calificacionPersonaId=' +
              this.infoCrediticia.tipoCalificacionId
          );

          console.log('Política x Plan:');
          console.log(result);

          this.politicaComercial = result;
          this.model.politicaComercialId = this.politicaComercial.id;
        } catch (error) {
          // Error
          this.alertError(error);
        }
      }

      this.loadingProgress = false;
    },
    async loadPlanesDisponibles() {
      if (this.model.canalVentaId == 0) return;

      this.opcionesPlanes = [];
      this.loading = true;
      try {
        var result = await http.get(
          'businesscore/planesdisponiblesparacredito' +
            '?productoId=' +
            this.model.productoId +
            '&empresaId=' +
            this.model.empresaId +
            '&canalVentaId=' +
            this.model.canalVentaId +
            '&calificacionPersonaId=' +
            this.infoCrediticia.tipoCalificacionId
        );

        this.listPlanes = result.list;
        this.listPlanesDisponibles = this.listPlanes.filter(
          (p) => p.estaDisponible
        );
        if (result.list.length == 0) {
          this.model.planId = 0;
          this.alertWarning(
            'El producto seleccionado no tiene Planes vigentes que estén disponibles. Utilice otro producto.'
          );
        } else {
          this.model.planId = result.list[0].planId;
          await this.setPoliticaComercial();
          await this.calcularOpcionesPlan();
        }
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadProductosDisponibles() {
      if (this.model.canalVentaId == 0) return;

      this.opcionesPlanes = [];
      this.loading = true;
      try {
        var result = await http.get(
          'businesscore/productosdisponiblesparacredito' +
            '?empresaId=' +
            this.model.empresaId +
            '&canalVentaId=' +
            this.model.canalVentaId
        );

        this.listProductos = result.list;
        this.listProductosDisponibles = this.listProductos.filter(
          (p) => p.estaDisponible
        );
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async buscarPersonaPorDocumento(cui) {
      if (this.ingresoPor == 'cuil' && cui.toString().length != 11) {
        this.alertError(
          'Por favor, verifique el CUIL ingresado, debe tener 11 dígitos.'
        );
        return;
      }

      this.loading = true;
      try {
        var result = await http.get(
          'personas/listaporcui?cui=' + Number.parseFloat(cui)
        );
        if (result.count >= 1) {
          this.setPersonaBusqueda(result.list[0], false);
        } else {
          if (cui.toString().length == 11)
            this.setPersonaBusqueda(
              {
                id: '00000000-0000-0000-0000-000000000000',
                documento: 0,
                cui: cui,
                tipoSexoId: this.model.personaDto.tipoSexoId,
              },
              true
            );
          // nuevo ingreso
          else
            this.setPersonaBusqueda(
              {
                id: '00000000-0000-0000-0000-000000000000',
                documento: cui,
                cui: 0,
                tipoSexoId: this.model.personaDto.tipoSexoId,
              },
              true
            ); // nuevo ingreso
        }
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async legajoGuardado(confirmado) {
      this.showLegajo = false;
      if (confirmado) this.legajoCheck = true;
    },
    async setPersonaBusqueda(persona, buscarPorMotor) {
      console.log('setPersonaBusqueda: ');
      console.log(persona);

      this.model.cuotasARefinanciarORenovar = [];
      this.selectedPersonaBusqueda = persona;
      this.model.personaId = persona.id;

      // busco la info completa de la persona
      this.loadingProgress = true;
      try {
        var result = await http.get(
          'personas/infocrediticia?id=' +
            this.model.personaId +
            '&cuil=' +
            persona.cui +
            '&documento=' +
            persona.documento +
            '&sexoId=' +
            this.model.personaDto.tipoSexoId
        );
        this.infoCrediticia = result;

        console.log('info crediticia');
        console.log(this.infoCrediticia);

        this.model.personaDto = this.infoCrediticia.personaDto;
        if (this.model.personaDto.empleo) {
          this.model.personaDto.empleo.fechaIngreso = this.$moment(
            this.model.personaDto.empleo.fechaIngreso
          ).format('YYYY-MM-DD');
        }

        this.model.cui = this.infoCrediticia.cui;

        this.model.calificacionPersonaId =
          this.infoCrediticia.tipoCalificacionId;

        var dob = this.$moment(this.model.personaDto.fechaNacimiento).format(
          'YYYY-MM-DD'
        ); // Todo: ver qué pasa cuando graba
        this.model.personaDto.fechaNacimiento = dob;

        if (this.infoCrediticia.personaDto.tipoSituacionLaboralId > 0) {
          this.model.trabaja = 'true';
        } else {
        }

        if (buscarPorMotor) {
          try {
            var resultmotor = await http.get(
              'personas/getnombremotor?cuil=' +
                this.infoCrediticia.cui.toString()
            );

            this.model.personaDto.nombre = resultmotor.nombre;
            this.model.personaDto.apellido = resultmotor.apellido;
            var dobmotor = this.$moment(resultmotor.fechaNacimiento).format(
              'YYYY-MM-DD'
            );
            this.model.personaDto.fechaNacimiento = dobmotor;
            if (resultmotor.sexo == 'M') {
              this.model.personaDto.tipoSexoId = 1;
            } else {
              this.model.personaDto.tipoSexoId = 2;
            }

            console.log(resultmotor);

            if (resultmotor.nombre == '') {
              this.canEditNombre = true;
            } else {
              this.canEditNombre = false;
            }
          } catch (error) {
            this.alertError(error);
          }
        }

        await this.setPoliticaComercial();
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loadingProgress = false;
    },
    async cancelar() {
      const res = await this.$dialog.confirm({
        text: '¿Confirmar la cancelación de la carga?',
        title: 'Atención',
        persistent: true, // Parece que no funciona...
      });

      if (!res) {
        return;
      } else {
        this.clear();
      }
    },
    async clear() {
      this.infoCrediticia = null;
      this.legajoCheck = false;
      this.model = {
        empresaId: this.UiCustomUserSettings.empresaPredeterminadaId,
        canalVentaId: this.UiCustomUserSettings.canalVentaPredeterminadoId,
        cuotasARefinanciarORenovar: [],
        cui: 0,
        documento: 0,
        personaDto: {
          tipoSexoId: 1,
          nombre: '',
          apellido: '',
          fechaNacimiento: this.$moment(new Date()).format('YYYY-MM-DD'),
          tipoSituacionLaboralId: 1,
          empleo: { tipoSituacionLaboralId: 1 },
          domicilios: [{}],
          datosContacto: { telefonos: [] },
        },
        trabaja: 'false',
        ingresoMensual: 0,
        calificacionPersonaId: 0,
        planId: 0,
        capital: 0,
        cuotas: 0,
        importeCuota: 0,
        tablaCoeficientesId: 0,
        politicaComercialId: 0,
        seAutorizoPorExcepcion: false,
        usuarioQueAutorizo: '',
        motivoAutorizacion: '',
        importeCuotaMaxima: 0,
        diaCobroId: 0,
        cbu: '',
        cuentaDebito: {},
        solicitaDebito: false,
        tipoMedioPagoId: 1,
        fechaCarga: this.$moment(new Date()).format('YYYY-MM-DD'),
        solicitaDebitoATarjeta: false,
        tarjetaDebito: {},
      };

      this.step = 1;
    },
    async loadSituacionesLaborales() {
      this.loading = true;
      try {
        var result = await http.get('situacioneslaborales'); // traigo todas
        this.listSituacionesLaborales = result.list;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadSexo() {
      this.loading = true;
      try {
        var result = await http.get('tipossexo'); // traigo todas
        this.listSexos = result.list;
      } catch (error) {
        // Error
        Vue.$log.error(error);
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadDiasCobro() {
      this.loading = true;
      try {
        var result = await http.get('tiposdiacobro'); // traigo todas
        this.listDiasCobro = result.list;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadMediosPago() {
      this.loading = true;
      try {
        var result = await http.get('tiposmediopagocredito'); // traigo todas
        this.listMediosPago = result.list;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadFormasLlegada() {
      this.loading = true;
      try {
        var result = await http.get('tiposformallegada'); // traigo todas
        this.listFormasLlegada = result.list;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadDestinosCredito() {
      this.loading = true;
      try {
        var result = await http.get('tiposdestinocredito'); // traigo todas
        this.listDestinosCredito = result.list;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadEntidadesFinancieras() {
      this.loading = true;
      try {
        var result = await http.get('entidadesfinancieras'); // traigo todas
        this.listEntidadesFinancieras = result.list;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadCanalesVentaHabilitados() {
      this.loading = true;
      try {
        var result = await http.get(
          'canalesventa/habilitadosparausuario?soloActivos=true&usuarioId=' +
            this.user.id
        ); // traigo todas
        this.listCanalesVentaHabilitados = result.list;

        // extraigo las empresas de los canales habilitados
        this.listEmpresas = Array.from(
          new Set(this.listCanalesVentaHabilitados.map((i) => i.empresaId))
        ).map((id) => {
          return {
            id: id,
            nombre: this.listCanalesVentaHabilitados.find(
              (s) => s.empresaId === id
            ).empresaDescripcion,
            color: this.listCanalesVentaHabilitados.find(
              (s) => s.empresaId === id
            ).empresaColor,
          };
        });

        // selecciono la empresa predefinida del usuario
        if (this.UiCustomUserSettings.empresaPredeterminadaId > 0) {
          if (
            this.listEmpresas.find(
              (i) => i.id === this.UiCustomUserSettings.empresaPredeterminadaId
            )
          ) {
            this.model.empresaId =
              this.UiCustomUserSettings.empresaPredeterminadaId;
          }
        }

        // selecciono el canal de venta predefinido del usuario
        if (this.UiCustomUserSettings.canalVentaPredeterminadoId > 0) {
          if (
            this.listCanalesVentaHabilitados.find(
              (i) =>
                i.id === this.UiCustomUserSettings.canalVentaPredeterminadoId
            )
          ) {
            this.model.canalVentaId =
              this.UiCustomUserSettings.canalVentaPredeterminadoId;
          }
        }
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    updateDatosTarjeta(datos) {
      Vue.$log.debug(datos);
      this.model.tarjetaDebito = datos;
      this.model.tarjetaDebito.altaTarjeta = true;

      if (!this.model.tarjetaDebito.tarjetaValidada) {
        this.model.tarjetaDebito.tarjetaValidada = false;
        this.model.tarjetaDebito.mesVto = '01';
        this.model.tarjetaDebito.anioVto = '1';
        this.model.tarjetaDebito.diaCobroId =
          this.model.personaDto.empleo.diaCobroId;
        this.model.tarjetaDebito.personaId = this.model.personaId;
        this.model.tarjetaDebito.clienteCardcred = 0;
        this.model.tarjetaDebito.operacionCarcred = 0;
        this.model.tarjetaDebito.formatoEnvioId = 0;
      }

      Vue.$log.debug(datos);
    },
    async validarMontoCuotas(){
      console.log(this.model.personaId);
      console.log(this.model.importeCuota);

      if (this.model.cuotas <= 0) {
        this.alertWarning("Debe ingresar un número de cuotas válido.");
        return;
      }

      this.loading = true;

      try {
        var result = await http.post( 
          "creditos/validarmontocuotas", {
            solicitud: {
              personaId: this.model.personaId,
              importeCuota: this.model.importeCuota
            }
          }
        );

        console.log(result);
        this.nextStep(3);

      } catch (error) {
        this.alertError(error);
      }
      this.loading = false;
    }
  },
};
</script>
